module.exports = ".nav.nav-tabs{padding-top:.5em;margin-top:-1em;margin-left:-2em;margin-right:-2em;margin-bottom:1em;-webkit-box-shadow:0px 0px 20px 0px rgba(0,0,0,0.075);box-shadow:0px 0px 20px 0px rgba(0,0,0,0.075)}.nav.nav-tabs .nav-item .nav-link{cursor:pointer;font-weight:400;border:none;margin:0 0.8em}.nav.nav-tabs .nav-item:hover{border:none}.nav.nav-tabs .nav-item>.nav-link.active{font-weight:bold;border:none;border-bottom:3px solid}.nav.nav-tabs button.pull-right{margin-left:auto;margin-right:2em}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/context-menu/nav.context.component.sass
// module id = ./src/app/layout/context-menu/nav.context.component.sass
// module chunks = main